import type { BlogPostMeta } from './posts'

/**
 * Article-specific heroes live here so the page, image sitemap, and any future
 * visual index can resolve the same asset. Posts not listed here retain the
 * established topic-level fallback.
 */
export const ARTICLE_HEROES: Record<string, string> = {
  // October 7–19, 2026 editorial slots (ChatGPT-generated editorial illustrations).
  'does-extra-gum-have-microplastics': '/blog/heroes/does-extra-gum-have-microplastics.webp',
  'owala-vs-yeti-microplastics': '/blog/heroes/owala-vs-yeti-microplastics.webp',
  'does-poland-spring-have-microplastics': '/blog/heroes/does-poland-spring-have-microplastics.webp',
  'does-french-press-have-microplastics': '/blog/heroes/does-french-press-have-microplastics.webp',
  'best-non-toxic-spatula': '/blog/heroes/best-non-toxic-spatula.webp',
  'does-perrier-have-microplastics': '/blog/heroes/does-perrier-have-microplastics.webp',
  'does-moka-pot-have-microplastics': '/blog/heroes/does-moka-pot-have-microplastics.webp',
  'does-mountain-valley-spring-water-have-microplastics': '/blog/heroes/does-mountain-valley-spring-water-have-microplastics.webp',
  'does-spindrift-have-microplastics': '/blog/heroes/does-spindrift-have-microplastics.webp',
  'is-simple-modern-non-toxic': '/blog/heroes/is-simple-modern-non-toxic.webp',
  'is-fellow-aiden-plastic-free': '/blog/heroes/is-fellow-aiden-plastic-free.webp',
  'does-boxed-water-have-microplastics': '/blog/heroes/does-boxed-water-have-microplastics.webp',
  'does-acqua-panna-have-microplastics': '/blog/heroes/does-acqua-panna-have-microplastics.webp',
  'best-baby-bottles-microplastic-free': '/blog/heroes/best-baby-bottles-microplastic-free.webp',
  '7-day-microplastic-detox-challenge': '/blog/heroes/7-day-microplastic-detox-challenge.webp',
  'do-microplastic-removal-supplements-work': '/blog/heroes/do-microplastic-removal-supplements-work.webp',
  'does-tamarind-remove-microplastics': '/blog/heroes/does-tamarind-remove-microplastics.webp',
  'does-kimchi-remove-microplastics': '/blog/heroes/does-kimchi-remove-microplastics.webp',
  'foods-that-help-clear-microplastics': '/blog/heroes/foods-that-help-clear-microplastics.webp',
  'do-probiotics-remove-microplastics': '/blog/heroes/do-probiotics-remove-microplastics.webp',
  "microplastics-nursery-guide": "/blog/heroes/baby.webp",
  "microplastics-in-prenatal-vitamins": "/blog/heroes/best-plastic-free-food-storage.webp",
  'microplastics-in-baby-food-pouches': '/blog/heroes/baby.webp',
  'microplastics-and-children': '/blog/heroes/baby.webp',
  'microplastics-in-baby-products': '/blog/heroes/baby.webp',
  'microplastics-in-bottled-water': '/blog/heroes/water.webp',
  'does-fiji-water-have-microplastics': '/blog/heroes/water.webp',
  'best-glass-water-bottles': '/blog/heroes/best-glass-water-bottles.webp',
  'best-owala-water-bottles-microplastics': '/blog/heroes/best-owala-water-bottles-microplastics.webp',
  'best-plastic-free-coffee-makers': '/blog/heroes/best-plastic-free-coffee-makers.webp',
  'best-plastic-free-food-storage': '/blog/heroes/best-plastic-free-food-storage.webp',
  'can-you-microwave-rubbermaid': '/blog/heroes/can-you-microwave-rubbermaid.webp',
  'chewing-gum-brands-ranked-microplastics': '/blog/heroes/chewing-gum-brands-ranked-microplastics.webp',
  'do-keurig-coffee-makers-have-microplastics': '/blog/heroes/do-keurig-coffee-makers-have-microplastics.webp',
  'do-ninja-coffee-makers-have-microplastics': '/blog/heroes/microplastics-in-espresso-machines.webp',
  'do-ziploc-bags-release-microplastics': '/blog/heroes/do-ziploc-bags-release-microplastics.webp',
  'does-aeropress-leach-microplastics': '/blog/heroes/best-plastic-free-coffee-makers.webp',
  'does-canned-tuna-have-microplastics': '/blog/heroes/microplastics-in-canned-food.webp',
  'does-cheese-have-microplastics': '/blog/heroes/microplastics-in-milk-and-dairy.webp',
  'does-fairlife-have-microplastics': '/blog/heroes/microplastics-in-milk-and-dairy.webp',
  'does-instant-coffee-have-microplastics': '/blog/heroes/does-instant-coffee-have-microplastics.webp',
  'does-starbucks-coffee-contain-microplastics': '/blog/heroes/does-starbucks-coffee-contain-microplastics.webp',
  'epa-microplastics-drinking-water': '/blog/heroes/microplastics-water-filters-compared.webp',
  'foods-with-the-most-microplastics': '/blog/heroes/foods-with-the-most-microplastics.webp',
  'is-moccamaster-plastic-free': '/blog/heroes/best-plastic-free-coffee-makers.webp',
  'is-owala-non-toxic': '/blog/heroes/best-owala-water-bottles-microplastics.webp',
  'is-silicone-a-microplastic': '/blog/heroes/is-silicone-a-microplastic.webp',
  'microplastic-testing': '/blog/heroes/microplastics-water-filters-compared.webp',
  'microplastics-in-canned-food': '/blog/heroes/microplastics-in-canned-food.webp',
  'microplastics-in-coffee-by-brewing-method': '/blog/heroes/microplastics-in-coffee-by-brewing-method.webp',
  'microplastics-in-espresso-machines': '/blog/heroes/microplastics-in-espresso-machines.webp',
  'microplastics-in-iced-coffee-brands-ranked-summer-2026': '/blog/heroes/microplastics-in-iced-coffee-brands-ranked-summer-2026.webp',
  'microplastics-in-milk-and-dairy': '/blog/heroes/microplastics-in-milk-and-dairy.webp',
  'microplastics-in-tea-bags': '/blog/heroes/microplastics-in-tea-bags.webp',
  'microplastics-water-filters-compared': '/blog/heroes/microplastics-water-filters-compared.webp',
  'milk-brands-ranked-microplastics': '/blog/heroes/microplastics-in-milk-and-dairy.webp',
  'our-place-essentials-pan-trio-review': '/blog/our-place/trio-terracotta.jpg',
  'refillable-water-bottle-materials-compared': '/blog/heroes/refillable-water-bottle-materials-compared.webp',
  'stanley-vs-yeti-vs-hydroflask-vs-owala-microplastics': '/blog/heroes/stanley-vs-yeti-vs-hydroflask-vs-owala-microplastics.webp',
  'water-bottle-left-in-hot-car-microplastics': '/blog/heroes/water-bottle-left-in-hot-car-microplastics.webp',
  'what-our-132-product-scores-actually-rest-on': '/blog/heroes/blog-research-desk.webp',
  'microplastics-in-oat-milk-brands-ranked': '/blog/heroes/microplastics-in-oat-milk-brands-ranked.webp',
  'microplastics-in-travel-toiletries-hotel-water-plane-food': '/blog/heroes/microplastics-in-travel-toiletries-hotel-water-plane-food.webp',
  'coffee-pods-brand-comparison-microplastics-2026': '/blog/heroes/nespresso-vertuo-vs-original-microplastics.webp',
  'nespresso-vertuo-vs-original-microplastics': '/blog/heroes/nespresso-vertuo-vs-original-microplastics.webp',
  'pyrex-freshlock-vs-snapware-microplastics': '/blog/heroes/pyrex-freshlock-vs-snapware-microplastics.webp',
  'ikea-365-glass-containers-microplastics': '/blog/heroes/ikea-365-glass-containers-microplastics.webp',
  'reusable-nespresso-capsules-microplastics': '/blog/heroes/reusable-nespresso-capsules-microplastics.webp',
  'zerowater-vs-brita-microplastics': '/blog/heroes/zerowater-vs-brita-microplastics.webp',
  'does-ninja-crispi-have-microplastics': '/blog/heroes/does-ninja-crispi-have-microplastics.webp',
  'does-chemex-have-microplastics': '/blog/heroes/does-chemex-have-microplastics.webp',
  'does-hario-v60-have-microplastics': '/blog/heroes/does-hario-v60-have-microplastics.webp',
  'does-ember-mug-have-microplastics': '/blog/heroes/does-ember-mug-have-microplastics.webp',
  'does-contigo-autoseal-have-microplastics': '/blog/heroes/does-contigo-autoseal-have-microplastics.webp',
  'does-camelbak-eddy-have-microplastics': '/blog/heroes/does-camelbak-eddy-have-microplastics.webp',
  'does-hydrojug-traveler-have-microplastics': '/blog/heroes/does-hydrojug-traveler-have-microplastics.webp',
  'are-stasher-bags-safe': '/blog/heroes/are-stasher-bags-safe.webp',
  'is-caraway-cookware-non-toxic':
    '/blog/heroes/is-caraway-cookware-non-toxic.webp',
  'are-air-fryer-liners-safe':
    '/blog/heroes/are-air-fryer-liners-safe.webp',
  'does-voss-water-have-microplastics':
    '/blog/heroes/does-voss-water-have-microplastics.webp',
  'are-titanium-cutting-boards-safe':
    '/blog/heroes/are-titanium-cutting-boards-safe.webp',
  'are-oven-bags-safe-for-turkey':
    '/blog/heroes/are-oven-bags-safe-for-turkey.webp',
  'non-toxic-air-fryers':
    '/blog/heroes/non-toxic-air-fryers.webp',
  'is-hexclad-non-toxic':
    '/blog/heroes/is-hexclad-non-toxic.webp',
  'is-ceramic-cookware-safe':
    '/blog/heroes/is-ceramic-cookware-safe.webp',
  'non-toxic-rice-cookers':
    '/blog/heroes/non-toxic-rice-cookers.webp',
  'is-polyester-bad-for-you':
    '/blog/heroes/is-polyester-bad-for-you.webp',
  'do-plastic-wrapped-candies-contain-microplastics':
    '/blog/heroes/do-plastic-wrapped-candies-contain-microplastics.webp',
  'can-you-microwave-food-in-plastic-wrapper':
    '/blog/heroes/can-you-microwave-food-in-plastic-wrapper.webp',
  'do-plastic-salt-grinders-shed-microplastics':
    '/blog/heroes/do-plastic-salt-grinders-shed-microplastics.webp',
  'are-compostable-coffee-cups-plastic':
    '/blog/heroes/are-compostable-coffee-cups-plastic.webp',
  'do-plastic-bottle-caps-shed-microplastics':
    '/blog/heroes/do-plastic-bottle-caps-shed-microplastics.webp',
  // Existing editorial illustrations; these do not depict celebrity products.
  'jaden-smith-just-water-microplastics':
    '/blog/people/jaden-smith-web-summit-2019.jpg',
  'sam-leavitt-microplastics-glass-only-routine':
    '/blog/heroes/best-glass-water-bottles.webp',
  'kourtney-kardashian-poosh-plastic-free-kitchen':
    '/blog/people/kourtney-kardashian-gq.png',
  'bryan-johnson-microplastics-routine-sauna-evidence':
    '/blog/people/bryan-johnson-2026.jpg',
  'jason-momoa-mananalu-water-microplastics':
    '/blog/people/jason-momoa-comic-con-2018.jpg',
  'prince-william-laundry-microplastic-filter':
    '/blog/heroes/prince-william-laundry-microplastic-filter.webp',
  'does-evian-have-microplastics':
    '/blog/heroes/does-evian-have-microplastics.webp',
  'does-parchment-paper-have-plastic':
    '/blog/heroes/does-parchment-paper-have-plastic.webp',
  'is-polyester-clothing-plastic':
    '/blog/heroes/is-polyester-clothing-plastic.webp',
  'are-nylon-cooking-utensils-plastic':
    '/blog/heroes/are-nylon-cooking-utensils-plastic.webp',
  'does-colgate-toothpaste-have-microplastics':
    '/blog/heroes/does-colgate-toothpaste-have-microplastics.webp',
  'does-vaseline-have-microplastics':
    '/blog/heroes/does-vaseline-have-microplastics.webp',
  'does-essentia-water-have-microplastics':
    '/blog/heroes/does-essentia-water-have-microplastics.webp',
  'plastic-cutting-board-microplastics':
    '/blog/heroes/plastic-cutting-board-microplastics.webp',
  'do-protein-shaker-bottles-shed-microplastics':
    '/blog/heroes/do-protein-shaker-bottles-shed-microplastics.webp',
  'why-water-tests-miss-small-microplastics':
    '/blog/heroes/lake-geneva-small-microplastics-study.webp',
  'protein-shakes-ranked-microplastics-phthalates':
    '/blog/heroes/protein-shakes-ranked-microplastics-phthalates.webp',
  'does-premier-protein-have-microplastics':
    '/blog/heroes/does-premier-protein-have-microplastics.webp',
  'does-muscle-milk-have-microplastics':
    '/blog/heroes/does-muscle-milk-have-microplastics.webp',
  'drugstore-skincare-microplastics-audited':
    '/blog/heroes/drugstore-skincare-microplastics-audited.webp',
  'does-cerave-have-microplastics':
    '/blog/heroes/does-cerave-have-microplastics.webp',
  'does-cetaphil-have-microplastics':
    '/blog/heroes/does-cetaphil-have-microplastics.webp',
  'can-you-microwave-solo-cups':
    '/blog/heroes/can-you-microwave-solo-cups.webp',
  'can-you-microwave-ziploc-bags':
    '/blog/heroes/can-you-microwave-ziploc-bags.webp',
  'nanoplastics-placenta-hormones-study-2026':
    '/blog/heroes/nanoplastics-placenta-hormones-study-2026.webp',

  // ── Shared heroes, 2026-08-10 ──────────────────────────────────────────────
  // Every image above was commissioned for one article, but most depict a
  // SUBJECT rather than a specific product, so they serve the whole cluster
  // around them. Before this, 199 of 246 articles fell through to one of eight
  // generic topic images, which meant the blog index showed the same eight
  // pictures over and over and every social card in a cluster looked identical.
  //
  // These pairings were made by LOOKING at each image, not by matching slugs.
  // That mattered more than expected — the file named after the placenta study
  // is a petri dish of beads on a lab bench, so it belongs on research articles
  // (blood, brain, arterial plaque) and NOT on pregnancy product articles like
  // breast pumps or pregnancy pillows. Deliberately left on their generic topic
  // hero: face masks, diapers, wet wipes, pregnancy pillows, breast pumps,
  // tap-water-by-geography and vitamins — no image on hand
  // actually depicts them, and a wrong picture reads worse than a plain one.

  'are-cans-lined-with-plastic':
    '/blog/heroes/microplastics-in-canned-food.webp',
  'are-nalgene-bottles-safe-microplastics': '/blog/heroes/refillable-water-bottle-materials-compared.webp',
  'are-stanley-cups-non-toxic-microplastic-audit':
    '/blog/heroes/stanley-vs-yeti-vs-hydroflask-vs-owala-microplastics.webp',
  'are-vacuum-sealer-bags-safe-microplastics':
    '/blog/heroes/do-ziploc-bags-release-microplastics.webp',
  'best-electrolyte-powders-without-microplastics':
    '/blog/heroes/protein-shakes-ranked-microplastics-phthalates.webp',
  'best-microplastic-free-toothpaste':
    '/blog/heroes/drugstore-skincare-microplastics-audited.webp',
  'best-reusable-k-cup-pods-stainless-steel-ranked':
    '/blog/heroes/do-k-cups-release-microplastics.webp',
  'best-reverse-osmosis-systems-for-microplastics':
    '/blog/heroes/microplastics-water-filters-compared.webp',
  'best-stainless-steel-water-bottles':
    '/blog/heroes/refillable-water-bottle-materials-compared.webp',
  'best-sunscreens-without-microplastics-brands-ranked':
    '/blog/heroes/drugstore-skincare-microplastics-audited.webp',
  'best-water-filter-pitchers-ranked':
    '/blog/heroes/microplastics-water-filters-compared.webp',
  'borosilicate-glass-vs-soda-lime-microplastics': '/blog/heroes/borosilicate-glass-vs-soda-lime-microplastics.webp',
  'clean-beauty-microplastics-loophole':
    '/blog/heroes/cosmetics.webp',
  'dishwasher-microplastics-plastic-containers':
    '/blog/heroes/best-plastic-free-food-storage.webp',
  'do-brita-filters-remove-microplastics':
    '/blog/heroes/microplastics-water-filters-compared.webp',
  'do-coffee-filters-have-microplastics':
    '/blog/heroes/microplastics-in-coffee-by-brewing-method.webp',
  'do-energy-drinks-have-microplastics':
    '/blog/heroes/protein-shakes-ranked-microplastics-phthalates.webp',
  'do-zyn-pouches-have-microplastics':
    '/blog/heroes/chewing-gum-brands-ranked-microplastics.webp',
  'does-almond-milk-have-microplastics': '/blog/heroes/microplastics-in-milk-and-dairy.webp',
  'does-aquatru-remove-microplastics':
    '/blog/heroes/microplastics-water-filters-compared.webp',
  'does-berkey-filter-microplastics':
    '/blog/heroes/microplastics-water-filters-compared.webp',
  'does-clearly-filtered-remove-microplastics':
    '/blog/heroes/microplastics-water-filters-compared.webp',
  'does-crest-have-microplastics':
    '/blog/heroes/drugstore-skincare-microplastics-audited.webp',
  'does-dunkin-coffee-contain-microplastics':
    '/blog/heroes/does-starbucks-coffee-contain-microplastics.webp',
  'does-fenty-beauty-have-microplastics':
    '/blog/heroes/cosmetics.webp',
  'does-huda-beauty-have-microplastics':
    '/blog/heroes/cosmetics.webp',
  'does-hydroflask-have-microplastics':
    '/blog/heroes/stanley-vs-yeti-vs-hydroflask-vs-owala-microplastics.webp',
  'does-kylie-cosmetics-have-microplastics':
    '/blog/heroes/cosmetics.webp',
  'does-neutrogena-have-microplastics':
    '/blog/heroes/drugstore-skincare-microplastics-audited.webp',
  'does-orbit-gum-have-microplastics':
    '/blog/heroes/chewing-gum-brands-ranked-microplastics.webp',
  'does-pur-gum-have-microplastics':
    '/blog/heroes/chewing-gum-brands-ranked-microplastics.webp',
  'does-rhode-have-microplastics':
    '/blog/heroes/cosmetics.webp',
  'does-sensodyne-have-microplastics':
    '/blog/heroes/drugstore-skincare-microplastics-audited.webp',
  'does-simply-gum-have-microplastics':
    '/blog/heroes/chewing-gum-brands-ranked-microplastics.webp',
  'does-yeti-have-microplastics':
    '/blog/heroes/stanley-vs-yeti-vs-hydroflask-vs-owala-microplastics.webp',
  'fruit-vegetables-biggest-microplastic-source-diet':
    '/blog/heroes/foods-with-the-most-microplastics.webp',
  'how-much-plastic-do-we-eat-per-week':
    '/blog/heroes/foods-with-the-most-microplastics.webp',
  'how-to-check-cosmetic-ingredients-for-microplastics-2026':
    '/blog/heroes/drugstore-skincare-microplastics-audited.webp',
  'is-rubbermaid-safe-microplastics':
    '/blog/heroes/best-plastic-free-food-storage.webp',
  'is-tritan-a-microplastic':
    '/blog/heroes/is-tritan-a-microplastic.webp',
  'is-tupperware-safe-microplastics':
    '/blog/heroes/is-tupperware-safe-microplastics.webp',
  'how-long-do-microplastics-stay-in-your-body':
    '/blog/heroes/how-long-do-microplastics-stay-in-your-body.webp',
  'microplastics-and-aging-skin-collagen':
    '/blog/heroes/drugstore-skincare-microplastics-audited.webp',
  'microplastics-and-alzheimers-dementia':
    '/blog/heroes/nanoplastics-placenta-hormones-study-2026.webp',
  'microplastics-and-cancer':
    '/blog/heroes/nanoplastics-placenta-hormones-study-2026.webp',
  'microplastics-and-fertility':
    '/blog/heroes/nanoplastics-placenta-hormones-study-2026.webp',
  'microplastics-synthetic-underwear-male-fertility':
    '/blog/heroes/synthetic-underwear-male-fertility.webp',
  'microplastics-and-miscarriage-risk':
    '/blog/heroes/nanoplastics-placenta-hormones-study-2026.webp',
  'microplastics-and-preeclampsia':
    '/blog/heroes/nanoplastics-placenta-hormones-study-2026.webp',
  'microplastics-and-skin-absorption':
    '/blog/heroes/microplastics-and-skin-absorption.webp',
  'do-toothbrush-bristles-shed-microplastics':
    '/blog/heroes/do-toothbrush-bristles-shed-microplastics.webp',
  'microplastics-in-amniotic-fluid':
    '/blog/heroes/microplastics-in-amniotic-fluid.webp',
  'microplastics-in-arterial-plaque':
    '/blog/heroes/nanoplastics-placenta-hormones-study-2026.webp',
  'microplastics-in-baby-skincare-and-sunscreen':
    '/blog/heroes/drugstore-skincare-microplastics-audited.webp',
  'microplastics-in-bread':
    '/blog/heroes/foods-with-the-most-microplastics.webp',
  'microplastics-from-breast-pump-parts': '/blog/heroes/baby.webp',
  'are-breast-pumps-safe-microplastics': '/blog/heroes/baby.webp',
  'microplastics-in-baby-formula': '/blog/heroes/baby.webp',
  'microplastics-in-breast-milk':
    '/blog/heroes/microplastics-in-breast-milk.webp',
  'microplastics-in-canned-tuna-and-salmon':
    '/blog/heroes/microplastics-in-canned-food.webp',
  'microplastics-in-cereal':
    '/blog/heroes/foods-with-the-most-microplastics.webp',
  'microplastics-in-chocolate':
    '/blog/heroes/foods-with-the-most-microplastics.webp',
  'microplastics-in-coffee':
    '/blog/heroes/microplastics-in-coffee-by-brewing-method.webp',
  'microplastics-in-coffee-creamer':
    '/blog/heroes/microplastics-in-milk-and-dairy.webp',
  'microplastics-in-coffee-cups':
    '/blog/heroes/does-starbucks-coffee-contain-microplastics.webp',
  'microplastics-in-cosmetics':
    '/blog/heroes/drugstore-skincare-microplastics-audited.webp',
  'microplastics-in-deodorant-brands-ranked':
    '/blog/heroes/drugstore-skincare-microplastics-audited.webp',
  'microplastics-in-disposable-cutlery':
    '/blog/heroes/can-you-microwave-solo-cups.webp',
  'microplastics-in-eggs':
    '/blog/heroes/nanoplastics-placenta-hormones-study-2026.webp',
  'microplastics-in-fast-food':
    '/blog/heroes/foods-with-the-most-microplastics.webp',
  'microplastics-in-fast-food-packaging':
    '/blog/heroes/foods-with-the-most-microplastics.webp',
  'microplastics-in-fruits-and-vegetables':
    '/blog/heroes/foods-with-the-most-microplastics.webp',
  'microplastics-in-honey':
    '/blog/heroes/foods-with-the-most-microplastics.webp',
  'microplastics-in-human-blood':
    '/blog/heroes/microplastics-in-human-blood.webp',
  'microplastics-in-ice-cream':
    '/blog/heroes/microplastics-in-milk-and-dairy.webp',
  'microplastics-in-k-cups-and-coffee-pods':
    '/blog/heroes/nespresso-vertuo-vs-original-microplastics.webp',
  'microplastics-in-kombucha':
    '/blog/heroes/microplastics-in-tea-bags.webp',
  'microplastics-in-makeup-brands-audited':
    '/blog/heroes/cosmetics.webp',
  'microplastics-in-meat':
    '/blog/heroes/foods-with-the-most-microplastics.webp',
  'microplastics-in-pasta':
    '/blog/heroes/foods-with-the-most-microplastics.webp',
  'microplastics-in-placenta':
    '/blog/heroes/microplastics-in-placenta.webp',
  'microplastics-in-plastic-containers':
    '/blog/heroes/best-plastic-free-food-storage.webp',
  'microplastics-in-plastic-wrap':
    '/blog/heroes/best-plastic-free-food-storage.webp',
  'microplastics-in-pregnancy':
    '/blog/heroes/nanoplastics-placenta-hormones-study-2026.webp',
  'microplastics-in-pregnancy-by-trimester':
    '/blog/heroes/nanoplastics-placenta-hormones-study-2026.webp',
  'microplastics-in-protein-powder-supplements':
    '/blog/heroes/protein-shakes-ranked-microplastics-phthalates.webp',
  'microplastics-in-rice':
    '/blog/heroes/foods-with-the-most-microplastics.webp',
  'microplastics-in-salt':
    '/blog/heroes/foods-with-the-most-microplastics.webp',
  'microplastics-in-seafood':
    '/blog/heroes/foods-with-the-most-microplastics.webp',
  'microplastics-in-shampoo-and-conditioner':
    '/blog/heroes/drugstore-skincare-microplastics-audited.webp',
  'microplastics-in-sous-vide':
    '/blog/heroes/are-stasher-bags-safe.webp',
  'microplastics-in-the-brain':
    '/blog/heroes/nanoplastics-placenta-hormones-study-2026.webp',
  'microplastics-in-yogurt':
    '/blog/heroes/microplastics-in-milk-and-dairy.webp',
  'microwaving-plastic-containers-microplastics':
    '/blog/heroes/microwaving-plastic-containers-microplastics.webp',
  'pfas-in-dental-floss':
    '/blog/heroes/drugstore-skincare-microplastics-audited.webp',
  'plastic-wrap-ziploc-bags-microplastics':
    '/blog/heroes/do-ziploc-bags-release-microplastics.webp',
  'pyrex-vs-anchor-hocking-glass-food-storage':
    '/blog/heroes/best-plastic-free-food-storage.webp',
  'red-solo-cups-plastic-party-supplies-microplastics':
    '/blog/heroes/can-you-microwave-solo-cups.webp',
  'styrofoam-takeout-containers-microplastics':
    '/blog/heroes/best-plastic-free-food-storage.webp',
  'what-does-microwave-safe-actually-mean':
    '/blog/heroes/microwaving-plastic-containers-microplastics.webp',
}

const TOPIC_HEROES: Record<BlogPostMeta['topic'], string> = {
  water: '/blog/heroes/water.webp',
  food: '/blog/heroes/food.webp',
  pregnancy: '/blog/heroes/baby.webp',
  home: '/blog/heroes/home.webp',
  health: '/blog/heroes/health.webp',
  cosmetics: '/blog/heroes/cosmetics.webp',
  clothing: '/blog/heroes/clothing.webp',
  general: '/blog/heroes/general.webp',
}

export const BLOG_INDEX_HERO = '/blog/heroes/blog-research-desk.webp'

export function getBlogHeroImage(
  post: Pick<BlogPostMeta, 'slug' | 'topic'>
): string {
  return ARTICLE_HEROES[post.slug] ?? TOPIC_HEROES[post.topic]
}
